import type { Signal } from '@preact/signals-react';
import { useSignalEffect } from '@preact/signals-react';
import { DateSelectionType } from 'beesoft-components';
import type { Duration } from 'date-fns';
import { add } from 'date-fns';
import { useState } from 'react';
import { forceAssert } from '../../common-functions';
import type { DynamicFormParentFieldValue } from '../../dynamic-form/dynamic-form.interfaces';
import type { DropDownResult } from '../drop-down/drop-down-types';
import type { OdinDateTimeProps } from './date-time.component';
import OdinDateTime from './date-time.component';

export interface OdinDateCompetencyProps extends OdinDateTimeProps {
  parentValue?: Signal<Array<DynamicFormParentFieldValue>>;
}
export default function OdinDateCompetency({
  label,
  value,
  error = '',
  onChange,
  readOnly,
  required,
  currentTimeBtn,
  parentValue,
  disabled,
}: OdinDateCompetencyProps) {
  const [innerValue, setInnerValue] = useState<Date | Date[] | undefined | string>(value);

  useSignalEffect(() => {
    //Update only if there are any user changes
    //initial value from BE must be kept
    const notAllValuesDefault = parentValue?.value
      ? parentValue.value.filter((item) => !item.initialValue)?.length > 0
      : false;
    if (parentValue?.value && notAllValuesDefault) {
      let parentDate: string | undefined;
      let trainingDuration: Duration | undefined;
      parentValue.value.forEach((valueItem) => {
        if (valueItem.type === 'DATEFIELD') {
          parentDate = valueItem.fieldValue as string;
        } //renewalInterval
        else if (
          valueItem.type === 'CUSTOM' &&
          forceAssert<DropDownResult>(valueItem.fieldValue).originalData?.renewalInterval
        ) {
          // TODO: FIX THIS...renewalInterval cannot be guaranteed to exist in the data. This is a reusable component
          //  and should not depend on data that is not known to the component.
          const renewalInterval = forceAssert<DropDownResult>(valueItem.fieldValue).originalData?.renewalInterval as {
            unit: string;
            amount: number;
          };
          trainingDuration = { [renewalInterval.unit.toLowerCase()]: renewalInterval.amount };
        }
      });
      let result: Date | undefined;
      if (parentDate && trainingDuration) {
        result = add(new Date(parentDate), trainingDuration);
      }
      setInnerValue(result);
      onChange?.(result);
    }
  });

  return (
    <OdinDateTime
      label={label}
      value={innerValue}
      error={error}
      currentTimeBtn={currentTimeBtn}
      onChange={onChange}
      dateSelectionType={DateSelectionType.DateOnly}
      readOnly={readOnly}
      required={required}
      disabled={disabled}
    />
  );
}
